import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
// import { MatExpansionModule } from '@angular/material/expansion';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { stringify } from '@angular/core/src/util';


@Component({
  selector: 'app-traveler',
  templateUrl: './traveler.component.html',
  styleUrls: ['./traveler.component.css']
})
export class TravelerComponent implements OnInit {

  passport_attach: File = null;
  panelOpenState = false;

  countryList = [];
  city = [];
  cityList = [];
  faqihList = [];
  saveClicked = false;

  pass_type_list = [{ 'key': 'independent ', 'type_name': 'مستقل', 'type_name_en': 'Independent ' },
    { 'key': 'dependent', 'type_name': 'غير مستقل', 'type_name_en': 'Dependent' }];

  model = {
    'table_name': 'customer', 'customer_id': '0', 'customer_name': '', 'customer_name_en': '',
    'customer_last_name': '', 'acct_number': '', 'national_id': '', 'customer_category_id': '0', 
    'tax_no': '', 'city_id': '1', 'address': '', 'street_name': '', 'additional_street_name': '', 
    'building_number': '', 'additional_number': '', 'neighbourhood': '', 'postal_zone': '', 
    'state_of_city': '', 'mobile': '', 'phone1': '', 'phone2': '', 'fax': '', 
    'email': '', 'bank_name': '', 'bank_acct_number': '', 'represent1': '', 'represent1_mobile': '', 
    'represent2': '', 'represent2_mobile': '', 'def_rep_no': '0', 'claim_day': 0, 'comment': '', 
    'car_type': '', 'key': 'customer_id', 'flag': 'new', 'car_model': '', 'car_color': '', 'is_account': '1', 
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'marital_status': '', 
    'customer_cr': '', 'agent_acct_number': ''
  };

  traveler_model = {
    'table_name': 'traveler_info', 'info_id': '0', 'acct_number': '', 'date_of_birth': '', 'gender': 'm',
    'occupation': '', 'passport_no': '', 'passport_issue_date': '', 'passport_issue_location': '',
    'key': 'info_id', 'flag': 'new', 'passport_expiry_date': '', 'smoker': 'false', 'medical_care': 'false',
    'nationality': '1', 'passport_type': '', 'passport_attach': '', 'comment': '',
    'reference': ''
  };

  base_model = {
    'table_name': 'acct_base', 'baseline_id': '0', 'base_date': '', 'acct_number': '',
    'main_acct_no': this.applicationConstants.main_acct_config['customer'],
    'acct_type_no': this.applicationConstants.acct_type_config['customer'], 'key': 'baseline_id',
    'flag': 'new', 'baseline_amount': '0', 'comment': ''
  };

  sub_acct_model = {
    'table_name': 'sub_acct', 'sub_acct_id': '0',
    'acct_type_no': this.applicationConstants.acct_type_config['customer'],
    'main_acct_no': this.applicationConstants.main_acct_config['customer'], 'sub_acct_name': '',
    'sub_acct_name_en': '', 'acct_number': '', 'parent_acct': this.applicationConstants.main_acct_config['customer'],
    'acct_level': '1', 'is_leaf': '1', 'is_cc': '1', 'tax_acct': '0', 'emp_no': '0', 'cc_no': '0',
    'key': 'sub_acct_id', 'flag': 'new', 'comment': '', 'auto_set': '0', 'set_type': 'count'
  };

  country_model = { 'country_id': '1' };
  data_model = {
    'date_of_birth': new Date("01-01-1980"), 'passport_issue_date': new Date(),
    'passport_expiry_date': new Date(), 'base_date': new Date(this.applicationConstants.business_cycle.start_date),
    'dob_year': '', 'dob_month': '', 'dob_day': '', 'for_all_branch': '0',
    'pid_year': '', 'pid_month': '', 'pid_day': '', 'ped_year': '', 'ped_month': '', 'ped_day': ''
  };

  year_list = [];

  month_list = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

  day_list = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10',
    '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
    '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'];

  statusList = [{ 'status_id': '', 'status_name': 'اختر', 'status_name_en': 'Select' },
    { 'status_id': 'single', 'status_name': 'أعزب', 'status_name_en': 'Single' },
    { 'status_id': 'married', 'status_name': 'متزوج', 'status_name_en': 'Married' },
    { 'status_id': 'divorced', 'status_name': 'مطلق', 'status_name_en': 'Divorced' },
    { 'status_id': 'Widower', 'status_name': 'أرمل', 'status_name_en': 'Widower' }];

  Success_Msg; Error_Msg; Name_Msg; Mobile_Msg; Dob_Msg;
  Passport_No_Msg; File_Size_Msg; Trav_Exist_Msg; Traveler_No; Mobile;
  File_Type_Msg; Country_Msg; City_Msg; Nationality_Msg; Hijri_Date_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<TravelerComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Name_Msg').subscribe((res: string) => {
      this.Name_Msg = res;
    });

    translate.get('Mobile_Msg').subscribe((res: string) => {
      this.Mobile_Msg = res;
    });
    
    translate.get('Dob_Msg').subscribe((res: string) => {
      this.Dob_Msg = res;
    });

    translate.get('Passport_No_Msg').subscribe((res: string) => {
      this.Passport_No_Msg = res;
    });

    translate.get('File_Size_Msg').subscribe((res: string) => {
      this.File_Size_Msg = res;
    });

    translate.get('File_Type_Msg').subscribe((res: string) => {
      this.File_Type_Msg = res;
    });

    translate.get('Country_Msg').subscribe((res: string) => {
      this.Country_Msg = res;
    });

    translate.get('City_Msg').subscribe((res: string) => {
      this.City_Msg = res;
    });

    translate.get('Nationality_Msg').subscribe((res: string) => {
      this.Nationality_Msg = res;
    });

    translate.get('Hijri_Date_Msg').subscribe((res: string) => {
      this.Hijri_Date_Msg = res;
    });
    
    translate.get('Trav_Exist_Msg').subscribe((res: string) => {
      this.Trav_Exist_Msg = res;
    });
    
    translate.get('Traveler_No').subscribe((res: string) => {
      this.Traveler_No = res;
    });
    
    translate.get('Mobile').subscribe((res: string) => {
      this.Mobile = res;
    });
  }

  ngOnInit() {
    let query, obj;

    query = this.queryList.all_country;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.countryList = data.data['list'];
      });

    query = this.queryList.all_city;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.city = data.data['list'];
        // if (this.dialog_data != null)
        this.getCity();
      });

    let current_year = new Intl.DateTimeFormat('ar-TN-u-ca-islamic', {year : 'numeric'}).format(Date.now()).substring(0, 4);
    this.year_list = this.rangeBetween(Number(current_year) - 120, Number(current_year) + 50);

    // query = "SELECT * FROM `faqih` WHERE `status` = '1'";
    // obj = { cmd: 'getList', query: query };
    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.faqihList = data.data['list'];
    //   });

    //Edit Traveler:
    if (this.dialog_data != null) {
      this.model = this.dialog_data['0'];
      this.country_model = this.dialog_data['1'];

      query = "SELECT * FROM `traveler_info` WHERE `acct_number` = '" + this.model['acct_number'] +
        "' AND `status` = '1'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let traveler = data.data['list'];

          this.traveler_model = {
            'table_name': 'traveler_info', 'info_id': traveler['0']['info_id'], 'acct_number': traveler['0']['acct_number'],
            'date_of_birth': traveler['0']['date_of_birth'], 'gender': traveler['0']['gender'],
            'occupation': traveler['0']['occupation'], 'passport_no': traveler['0']['passport_no'],
            'passport_issue_date': traveler['0']['passport_issue_date'],
            'passport_issue_location': traveler['0']['passport_issue_location'],
            'key': 'info_id', 'flag': 'update', 'passport_expiry_date': traveler['0']['passport_expiry_date'],
            'smoker': traveler['0']['smoker'], 'medical_care': traveler['0']['medical_care'],
            'nationality': traveler['0']['nationality'],
            'passport_type': traveler['0']['passport_type'], 'passport_attach': '', 'comment': traveler['0']['comment'],
            'reference': traveler['0']['reference']
          };

          if (this.traveler_model['medical_care'] == 'true')
            (document.getElementById('medical_care') as HTMLInputElement).checked = true;

          this.data_model['date_of_birth'] = new Date(this.traveler_model['date_of_birth']);
          this.data_model['passport_issue_date'] = new Date(this.traveler_model['passport_issue_date']);
          this.data_model['passport_expiry_date'] = new Date(this.traveler_model['passport_expiry_date']);
          this.data_model['for_all_branch'] = (this.model['branch_id'] == '0' ? '1' : '0');

          this.sub_acct_model['acct_number'] = this.model['acct_number'];
          this.sub_acct_model['comment'] = this.model['comment'];
          this.sub_acct_model['flag'] = 'update';

          // get sub acct
          query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              if (data.data['list'].length > 0) {
                let sub_acct = data.data['list'][0];
                this.sub_acct_model['sub_acct_id'] = sub_acct['sub_acct_id'];
                this.sub_acct_model['sub_acct_name'] = sub_acct['sub_acct_name'];
                this.sub_acct_model['sub_acct_name_en'] = sub_acct['sub_acct_name_en'];
                this.sub_acct_model['parent_acct'] = sub_acct['parent_acct'];
                this.sub_acct_model['acct_level'] = sub_acct['acct_level'];
                this.sub_acct_model['is_leaf'] = sub_acct['is_leaf'];
                this.sub_acct_model['is_cc'] = sub_acct['is_cc'];
                this.sub_acct_model['tax_acct'] = sub_acct['tax_acct'];
              }
            });
        });
    }
    else {
      console.log(this.applicationConstants.main_acct_config['customer']);
      // get acct_level
      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.sub_acct_model['parent_acct'] + "'";
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0)
            this.sub_acct_model['acct_level'] = String(Number(data.data['list'][0]['acct_level']) + 1);
          else
            this.sub_acct_model['acct_level'] = '3';
        });

      // get customer accts
      // let parent_acct = this.applicationConstants.main_acct_config['customer'];
      // obj = { cmd: 'getAccountList', parent_acct: parent_acct, include_parent: true, add_leaf: false};
      // this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      //   .subscribe(data => {
      //     this.applicationConstants.appComp.hideBusyCursor();

      //     if (data.data['list'].length > 0) {
      //       this.sub_acct_model['parent_acct'] = data.data['list'][0]['acct_number'];
      //       this.sub_acct_model['acct_level'] = String(Number(data.data['list'][0]['acct_level']) + 1);
      //     }
      //     else 
      //       this.sub_acct_model['parent_acct'] = parent_acct;

      //     let query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" +
      //       this.sub_acct_model['parent_acct'] + "'";
      //     console.log(query);
      //   });
    }
  }

  rangeBetween(start, end) {
    var arr = new Array(end - start + 1);
    for (var j = 0; j < arr.length; j++, start++) {
      arr[j] = start;
    }
    return arr;
  }

  changeForAllBranch() {
    this.data_model['for_all_branch'] = ((document.getElementById('for_all_branch') as HTMLInputElement).checked ? '1' : '0');
    this.model['branch_id'] = (this.data_model['for_all_branch'] == '1' ? '0' : this.applicationConstants.user_branch_info.user_branch_id);
  }

  convertHijriToGreg(type) {
    if(this.data_model[type + '_day'] == '' || this.data_model[type + '_month'] == '' || 
      this.data_model[type + '_year'] == '') {
      // alert(this.Hijri_Date_Msg);
      return
    }

    let julianDay = ((11 * Number(this.data_model[type + '_year']) + 3) / 30) + 354 * 
      Number(this.data_model[type + '_year']) + 30 * Number(this.data_model[type + '_month']) - 
      ((Number(this.data_model[type + '_month']) - 1) / 2) + Number(this.data_model[type + '_day']) + 
      1948440 - 385;

    let b = 0;
    if (julianDay > 2299160) {
      let a = Math.floor((julianDay - 1867216.25) / 36524.25);
      b = 1 + a - Math.floor(a / 4.0);
    }
    let bb = julianDay + b + 1524;
    let cc = Math.floor((bb - 122.1) / 365.25);
    let dd = Math.floor(365.25 * cc);
    let ee = Math.floor((bb - dd) / 30.6001);
    let day_f = String((bb - dd) - Math.floor(30.6001 * ee));
    let month = String(ee - 1);
    if (ee > 13) {
      cc += 1;
      month = String(ee - 13);
    }
    let year = String(cc - 4716);
    let day = (day_f.split('.'))[0];
    let gregDate = new Date(year + "-" + month + "-" + day);

    if (type == 'dob')
      this.data_model['date_of_birth'] = gregDate;
    else if (type == 'pid')
      this.data_model['passport_issue_date'] = gregDate;
    else if (type == 'ped')
      this.data_model['passport_expiry_date'] = gregDate;
  }

  getCity() {
    this.cityList = [];
    this.city.forEach(element => {
      if (element.country_id == this.country_model['country_id'])
        this.cityList.push(element);
    });
  }

  changeMedCare() {
    this.traveler_model['medical_care'] = ((document.getElementById('medical_care') as HTMLInputElement).checked ? 'true' : 'false');
  }

  fileSelected(event) {
    this.passport_attach = <File>event.target.files[0];
  }

  uploadPassportFile(info_id) {
    let file_extention, file_name, obj;

    file_extention = (this.passport_attach.name).substring((this.passport_attach.name).lastIndexOf('.'));
    file_name = 'pass_' + this.model['acct_number'] + file_extention;
    obj = {
      file_name: file_name, cmd: 'update',
      values: [{ 'table_name': 'traveler_info', 'passport_attach': file_name }],
      where: [{ 'info_id': info_id }]
    };

    this.utils.uploadFile(this.applicationConstants.uploadFile, this.passport_attach, obj)
      .subscribe(data => {

        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          this.dialog_data = { 'op_type': 'success' };
          this.dialogRef.close(this.dialog_data);
        }
        else
          alert(data.status['msg']);
      });
  }

  add() {
    this.saveClicked = true;

    if (this.model['customer_name'] == '') {
      (document.getElementById('customer_name') as HTMLInputElement).focus();
      alert(this.Name_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.country_model['country_id'] == '') {
      (document.getElementById('country_id') as HTMLInputElement).focus();
      alert(this.Country_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['city_id'] == '0') {
      (document.getElementById('city_id') as HTMLInputElement).focus();
      alert(this.City_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.traveler_model['nationality'] == '') {
      (document.getElementById('nationality') as HTMLInputElement).focus();
      alert(this.Nationality_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['mobile'] == '') {
      (document.getElementById('mobile') as HTMLInputElement).focus();
      alert(this.Mobile_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.data_model['date_of_birth'] == undefined) {
      (document.getElementById('date_of_birth') as HTMLInputElement).focus();
      alert(this.Dob_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.traveler_model['passport_no'] == '') {
      (document.getElementById('passport_no') as HTMLInputElement).focus();
      alert(this.Passport_No_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.passport_attach != null && this.passport_attach.size > 5000000) {
      alert(this.File_Size_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.passport_attach != null && this.passport_attach.type != "image/png" && this.passport_attach.type != "image/jpeg" &&
      this.passport_attach.type != "image/gif" && this.passport_attach.type != "application/pdf") {
      alert(this.File_Type_Msg);
      this.saveClicked = false;
      return;
    }

    let values = [];
    this.model['national_id'] = this.traveler_model['passport_no'];
    if (this.applicationConstants.user_info['user_id'] == undefined)
      this.model['agent_acct_number'] = this.applicationConstants.user_info['acct_number'];
    else 
      this.model['agent_acct_number'] = "";
    values.push(this.model);

    this.traveler_model['date_of_birth'] = (this.data_model['date_of_birth'].getFullYear() + '-' +
      (this.data_model['date_of_birth'].getMonth() + 1) + '-' + this.data_model['date_of_birth'].getDate());

    this.traveler_model['passport_issue_date'] = (this.data_model['passport_issue_date'].getFullYear() + '-' +
      (this.data_model['passport_issue_date'].getMonth() + 1) + '-' + this.data_model['passport_issue_date'].getDate());

    this.traveler_model['passport_expiry_date'] = (this.data_model['passport_expiry_date'].getFullYear() + '-' +
      (this.data_model['passport_expiry_date'].getMonth() + 1) + '-' + this.data_model['passport_expiry_date'].getDate());

    this.traveler_model['comment'] = this.model['comment'];

    values.push(this.traveler_model);

    // sub acct data
    this.sub_acct_model['sub_acct_name'] = this.model['customer_name'];
    this.sub_acct_model['sub_acct_name_en'] = this.model['customer_name_en'] + " " + this.model['customer_last_name'];
    this.sub_acct_model['comment'] = this.model['comment'];

    values.push(this.sub_acct_model);

    let obj;

    if (this.model['customer_id'] == '0') {
      let query;

      // check if the traveler is already available or not by checking the birth of date and passprot no
      // AND `traveler_info`.`date_of_birth` = '" + this.traveler_model['date_of_birth'] + "' 
      query = "SELECT `traveler_info`.`acct_number`, `customer`.`mobile` FROM `traveler_info`, `customer` " + 
        "WHERE `traveler_info`.`status` = '1' AND `traveler_info`.`passport_no` = '" + 
        this.traveler_model['passport_no'] + "' AND `traveler_info`.`acct_number` = `customer`.`acct_number`" + 
        (this.applicationConstants.user_info['user_id'] == undefined ? " AND `customer`.`agent_acct_number` = '" + this.applicationConstants.user_info['acct_number'] + "'" : " AND `customer`.`agent_acct_number` = ''");
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length == 0) {
            // add the traveler

            //add acct base
            this.base_model['base_date'] = this.data_model['base_date'].getFullYear() + '-' +
            (this.data_model['base_date'].getMonth() + 1) + '-' + this.data_model['base_date'].getDate() +
            ' 00:00:00';
            // this.data_model['base_date'].getFullYear() + '-01-01 00:00:00';
            // ' ' +  new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds();

            values.push(this.base_model);

            // generate acct number for traveler
            query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" +
              this.sub_acct_model['parent_acct'] + "'";
            obj = { cmd: 'getList', query: query };
            console.log(query);

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let result = data.data['list'][0]['acct_number'];
                if (result == '0')
                  this.model['acct_number'] = this.sub_acct_model['parent_acct'] + "001";
                else {
                  if (result.indexOf(this.sub_acct_model['parent_acct']) != -1) {
                    result = result.substring(result.indexOf(this.sub_acct_model['parent_acct']) + (this.sub_acct_model['parent_acct']).length);
                    console.log('result: ' + result);
                    result = String(Number(result) + 1);
                    if (Number(result) < 10)
                      result = '00' + result;
                    else if (Number(result) < 100)
                      result = '0' + result;

                    this.model['acct_number'] = this.sub_acct_model['parent_acct'] + result;
                  }
                  else
                    this.model['acct_number'] = String(Number(result) + 1);
                }
                console.log(this.model['acct_number']);

                this.traveler_model['acct_number'] = this.model['acct_number'];
                this.sub_acct_model['acct_number'] = this.model['acct_number'];
                this.base_model['acct_number'] = this.model['acct_number'];

                obj = { cmd: 'add', values: values };

                this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                  .subscribe(data => {
                    this.applicationConstants.appComp.hideBusyCursor();
                    if (data.status['type'] == 'success') {
                      // if (this.model['customer_id'] == '0')
                      //   this.model['acct_number'] = data.status['msg'][0]['number'];
                      console.log(data);
                      if (this.passport_attach != null) {
                        if (this.model['customer_id'] == '0')
                          this.uploadPassportFile(data.status['msg'][1]['id']);
                        else
                          this.uploadPassportFile(this.traveler_model['info_id']);
                      }
                      else {
                        alert(this.Success_Msg);
                        this.dialog_data = { 'op_type': 'success', 'acct_number': this.model['acct_number'] };
                        this.dialogRef.close(this.dialog_data);
                      }
                    }
                    else {
                      alert(this.Error_Msg);
                      this.saveClicked = false;
                    }
                  });
              });
          }
          else {
            let travelerInfo = data.data['list'][0];
            
            alert(this.Trav_Exist_Msg + ", " + this.Traveler_No + ": " + travelerInfo.acct_number + ", " + 
              this.Mobile + ": " + travelerInfo.mobile);
            this.saveClicked = false;
          }
        
        });

      // let prefix = '103' + this.model.city_id;
      // obj = { cmd: 'add', values: values, pk: 'acct_number', id: 'customer_id', main_table: 'customer', prefix: prefix };
    }
    else {
      obj = { cmd: 'updateAdv', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            // if (this.model['customer_id'] == '0')
            //   this.model['acct_number'] = data.status['msg'][0]['number'];
            console.log(data);
            if (this.passport_attach != null)
              this.uploadPassportFile(this.traveler_model['info_id']);
            else {
              alert(this.Success_Msg);
              this.dialog_data = { 'op_type': 'success', 'acct_number': this.model['acct_number'] };
              this.dialogRef.close(this.dialog_data);
            }
          }
          else {
            alert(this.Error_Msg);
            this.saveClicked = false;
          }

        });
    }

  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
